<template>
  <div class="company-data-wrapper">
    <div
      class="box"
      style="padding-top: 30px; padding-bottom: 30px"
      :class="currCompany && !currCompany.verificationTransferConfirmed ? 'box-small' : ''"
    >
      <form>
        <div class="">
          <div class="">
            <div class="grid-it">
              <div class="control control--input span-col">
                <label for="company" class="control__label">{{ $t("profile.company.name") }}</label>
                <input
                  disabled
                  style="background: rgba(162, 162, 162, 0.05)"
                  type="text"
                  id="company"
                  :placeholder="$t('register.company_placeholder')"
                  v-model="company"
                />
                <div v-show="errors.company" class="control__error">
                  <div class="control__error-inner">
                    {{ errors.company }}
                  </div>
                </div>
              </div>
            
              <div class="control control--input">
                <label for="address" class="control__label">{{ $t("profile.company.address") }}</label>
                <input
                  disabled
                  style="background: rgba(162, 162, 162, 0.05)"
                  type="text"
                  id="address"
                  :placeholder="$t('register.address_placeholder')"
                  v-model="address"
                />
                <div v-show="errors.address" class="control__error">
                  <div class="control__error-inner">
                    {{ errors.address }}
                  </div>
                </div>
              </div>
              <div class="control control--input">
                <label for="city" class="control__label">{{ $t("profile.company.city") }}</label>
                <input
                  disabled
                  style="background: rgba(162, 162, 162, 0.05)"
                  type="text"
                  id="city"
                  :placeholder="$t('register.city_placeholder')"
                  v-model="city"
                />
                <div v-show="errors.city" class="control__error">
                  <div class="control__error-inner">
                    {{ errors.city }}
                  </div>
                </div>
              </div>
              <div class="control control--input">
                <label for="country" class="control__label">{{ $t("register.country") }}</label>
                <input
                  disabled
                  style="background: rgba(162, 162, 162, 0.05)"
                  type="text"
                  id="country"
                  :placeholder="$t('register.country_placeholder')"
                  v-model="country"
                />
                <div v-show="errors.country" class="control__error">
                  <div class="control__error-inner">
                    {{ errors.country }}
                  </div>
                </div>
              </div>
              <div class="control control--input">
                <label for="phone" class="control__label">{{ $t("register.phone") }}</label>
                <input
                  disabled
                  style="background: rgba(162, 162, 162, 0.05)"
                  type="text"
                  id="phone"
                  :placeholder="$t('register.phone_placeholder')"
                  v-model="phone"
                />
                <div v-show="errors.phone" class="control__error">
                  <div class="control__error-inner">
                    {{ errors.phone }}
                  </div>
                </div>
              </div>
              <div class="control control--input">
                <label for="postCode" class="control__label">{{ $t("profile.company.zip_code") }}</label>
                <input
                  disabled
                  style="background: rgba(162, 162, 162, 0.05)"
                  type="text"
                  id="postCode"
                  pattern="^\d{2}-\d{3}$"
                  :placeholder="$t('register.zipCode_placeholder')"
                  v-model="zipCode"
                />
                <div v-show="errors.zipCode" class="control__error">
                  <div class="control__error-inner">
                    {{ errors.zipCode }}
                  </div>
                </div>
              </div>
              <div class="control control--input">
                <label for="nip" class="control__label">{{ $t("profile.company.nip") }}</label>
                <input
                  type="text"
                  id="nip"
                  :placeholder="$t('register.nip_placeholder')"
                  style="background: rgba(162, 162, 162, 0.05)"
                  v-model="nip"
                  :disabled="true"
                />
                <div v-show="errors.nip" class="control__error">
                  <div class="control__error-inner">
                    {{ errors.nip }}
                  </div>
                </div>
              </div>
              <div class="control control--input span-col">
                <label for="displayName" class="control__label">{{ $t("profile.company.display_name") }}</label>
                <input
                  :disabled="roleInCompany() !== 'OWNER'"
                  :style="roleInCompany() !== 'OWNER' ? 'background: rgba(162, 162, 162, 0.05)' : ''"
                  type="text"
                  id="displayName"
                  :placeholder="$t('profile.company.display_name_placeholder')"
                  v-model="displayName"
                  maxlength="50"
                />
                <div v-show="errors.displayName" class="control__error">
                  <div class="control__error-inner">
                    {{ errors.displayName }}
                  </div>
                </div>
              </div>
            </div>

            <div v-if="roleInCompany() === 'OWNER'" class="licenses-section">
              <div class="section-title">{{ $t("register.choose_licenses_description") }}</div>
              <div class="licenses-wrapper">
                <div v-for="licenseType in allLicenseTypes" :key="licenseType.type" class="license-item">
                  <div class="license-checkbox">
                    <input 
                      type="checkbox" 
                      :id="`license-${licenseType.type}`" 
                      v-model="selectedLicenses[licenseType.type]" 
                    />
                    <label :for="`license-${licenseType.type}`" class="license-label">
                      {{ $t(`enums.${licenseType.type}`) || licenseType.type }}
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div class="checkbox-positioning">
              <phone-number-chekckbox @checkChange="checked = !checked" :checked="checked"></phone-number-chekckbox>
            </div>
            <div class="col-2">
              <div style="display: grid; place-items: center" class="">
                <h1 v-if="profilePictureToDisplay?.file || roleInCompany() === 'OWNER'">{{ $t("profile.company.avatar") }}</h1>
                <div v-if="profilePictureToDisplay && profilePictureToDisplay?.file" class="image-wrapper image-wrapper-small">
                  <div>
                    <img class="picture-measurement" :src="profilePictureToDisplay.file" alt="Profile picture" />
                    <span v-if="roleInCompany() === 'OWNER'" @click="deleteProfilePicture">X</span>
                  </div>
                </div>
                <div v-if="roleInCompany() === 'OWNER'" style="margin-top: 5px" class="control control--input">
                  <label for="avatar" class="control__label galery-custom-btn">
                    <div class="input-as-button">{{ $t("profile.add_documents.choose_file") }}</div>
                  </label>
                  <input type="file" id="avatar" accept=".jpg, .jpeg, .png" style="display: none" @change="handlePicture" />
                </div>
              </div>
              <div style="text-align: center" class="">
                <div class="gallery-header" v-if="imagesToDisplay.length > 0 || roleInCompany() === 'OWNER'">
                  <h1>{{ $t("profile.company.galery") }}</h1>
                  <span class="image-counter">{{ imagesToDisplay.length }}/10</span>
                </div>

                <div class="image-wrapper">
                  <div v-for="(image, index) in imagesToDisplay" :key="index">
                    <img :key="index" :src="image.file" alt="Galery image" />
                    <span v-if="roleInCompany() === 'OWNER'" @click="removeFromGalery(image.id)">X</span>
                  </div>
                </div>
                
                <div v-if="roleInCompany() === 'OWNER' && imagesToDisplay.length < 10" style="margin-top: 2px" class="control control--input">
                  <label for="galery" class="control__label galery-custom-btn">
                    <div class="input-as-button">{{ $t("profile.add_documents.choose_files") }}</div>
                  </label>
                  <input type="file" id="galery" accept=".jpg, .jpeg, .png" style="display: none" @change="addPicture($event.target.files[0])" />
                </div>
                
                <div v-if="imagesToDisplay.length >= 10" class="limit-message">
                  Osiągnięto maksymalną liczbę zdjęć (10)
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div v-if="roleInCompany() === 'OWNER'" style="display: grid; place-items: center">
        <primary-button
          @click="saveCompanyColumn"
          :filled="true"
          :red="true"
          :title="authStore.isLoading ? $t('generals.saving') : $t('generals.save')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PhoneNumberChekckbox from "@/components/common/PhoneNumberChekckbox.vue";
import PrimaryButton from "@/components/common/PrimaryButton.vue";
import loader from "@/components/loader/index.vue";
import "@/css/company/company-data.scss";
import alertHelper from "@/helpsers/alert.helper";
import i18n from "@/i18n";
import storeCache from "@/js/storeCache";
import { checkFileType, roleInCompany } from "@/js/utils";
import { useCompanyStore } from "@/stores/company.store";
import { useHelpersStore } from "@/stores/helpers.store";
import { useField, useForm } from "vee-validate";
import { inject, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import * as yup from "yup";

const ALL_LICENSE_TYPES = [
  { type: "BF2", id: "BF2" },
  { type: "BF3", id: "BF3" },
  { type: "BF3_PLUS", id: "BF3_PLUS" },
  { type: "BF4", id: "BF4" },
  { type: "VLM", id: "VLM" },
];

export default {
  name: "CompanyData",
  props: ["mock", "allowSms"],
  components: {
    loader,
    PhoneNumberChekckbox,
    PrimaryButton,
  },
  setup(props) {
    const authStore = props.mock;
    let alert = inject("alert");
    const { t } = useI18n();
    const userCompany = useCompanyStore();
    const helpersStore = useHelpersStore();
    const companyId = storeCache.get("currentCompany")?.id;
    const currCompany = ref(null);
    let fetched = ref(false);
    const companyAddressId = ref(null);
    const companyAvatar = ref("");
    const companyGalery = ref([]);
    const imagesToDisplay = ref([]);
    const profilePictureToDisplay = ref(null);
    const galeryCopy = ref([]);
    const galleryUploading = ref(false);
    let checked = ref(props.allowSms);

    // License-related state
    const selectedLicenses = ref({});
    const allLicenseTypes = ref(ALL_LICENSE_TYPES);

    const initializeLicenses = () => {
      // Initialize all license types
      const licenseObj = {};
      ALL_LICENSE_TYPES.forEach((license) => {
        // Check if company has this license
        const hasLicense = currCompany.value?.drivingLicenses?.some((companyLicense) => companyLicense.type === license.type);
        licenseObj[license.type] = hasLicense || false;
      });
      selectedLicenses.value = licenseObj;
    };

    const { handleSubmit, errors } = useForm({
      validationSchema: yup.object().shape({
        company: yup.string().trim(),
        displayName: yup.string().max(50, t("profile.company.validation.display_name_max")).trim(),
        address: yup.string().trim(),
        city: yup
          .string()
          .matches(/^[A-Za-zżźćńółęąśŻŹĆĄŚĘŁÓŃ-]+(?:[\s-][A-Za-zżźćńółęąśŻŹĆĄŚĘŁÓŃ-]+)*$/, i18n.global.t("register.validation.string"))
          .required(i18n.global.t("register.validation.required")),
        country: yup
          .string()
          .matches(/^[A-Za-zżźćńółęąśŻŹĆĄŚĘŁÓŃ-]+$/, i18n.global.t("register.validation.string"))
          .required(i18n.global.t("register.validation.required")),
        zipCode: yup
          .string()
          .required(i18n.global.t("register.validation.required"))
          .matches(/^[a-zA-Z\d](?:[- ]*[a-zA-Z\d]){2,9}$/, t("profile.company.validation.zip_code"))
          .max(6, t("profile.company.validation.zip_code"))
          .trim(),
        nip: yup.string().min(5, t("profile.company.validation.max_nip")).max(11, t("profile.company.validation.max_nip")),
        phone: yup
          .string()
          .required(i18n.global.t("register.validation.required"))
          .matches(
            /^(?=(.{1,20})$)((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/,
            i18n.global.t("register.validation.phone")
          ),
      }),
      initialValues: {
        company: props.mock.company !== undefined ? props.mock.company.name : "",
        displayName: props.mock.company !== undefined ? props.mock.company.displayName || "" : "",
        address: props.mock.company !== undefined ? props.mock.company.address : "",
        city: props.mock.company !== undefined ? props.mock.company.city : "",
        zipCode: props.mock.company !== undefined ? props.mock.company.zipCode : "",
        nip: props.mock.company !== undefined ? props.mock.company.nip : "",
        phone: "",
        country: "",
      },
    });

    onMounted(async () => {
      authStore.isLoading = false;
      if (companyId !== null) {
        currCompany.value = await userCompany.fetchOneCompany(companyId);
        const { companyName, addresses, companyNip, companyPhone, documents, companyAvatar, displayName: companyDisplayName } = currCompany.value;
        const { companyAddress, companyCity, companyZipCode, id, companyCountry } = addresses[0];
        company.value = companyName;
        displayName.value = companyDisplayName || "";
        address.value = companyAddress;
        city.value = companyCity;
        zipCode.value = companyZipCode;
        nip.value = companyNip;
        phone.value = companyPhone;
        country.value = companyCountry;
        companyAddressId.value = id;
        
        // Initialize licenses after company data is loaded
        initializeLicenses();

        const fetchedImages = documents.filter((image) => image.type === "GALLERY" && image.isCompress);
        if (companyAvatar && companyAvatar?.id) {
          const file = await userCompany.getCompanyPicture(`${companyAvatar.id}`);
          profilePictureToDisplay.value = {
            id: companyAvatar?.id,
            file: URL.createObjectURL(file),
          };
        }
        for (let i = 0; i < fetchedImages.length; i++) {
          companyGalery.value.push({
            id: fetchedImages[i].id,
            file: await userCompany.getCompanyPicture(fetchedImages[i].id),
          });
        }
        companyGalery.value.reverse();
        galeryCopy.value = documents
          .filter((elem) => {
            if (elem.type === "GALLERY") return elem;
          })
          .map((elem) => {
            return elem.id;
          });
        mapImagesToDisplay();
        fetched.value = true;
      }
      galeryCopy.value.reverse();
      setTimeout(() => {
        helpersStore.adjustTasks();
      }, 1000);
    });

    const { value: company } = useField("company");
    const { value: displayName } = useField("displayName");
    const { value: address } = useField("address");
    const { value: city } = useField("city");
    const { value: zipCode } = useField("zipCode");
    const { value: nip } = useField("nip");
    const { value: phone } = useField("phone");
    const { value: country } = useField("country");

    const handlePicture = (file) => {
      if (checkFileType(file) && file.target.files[0].size <= 10_000_000) {
        companyAvatar.value = file.target.files[0];
        profilePictureToDisplay.value = {
          ...profilePictureToDisplay.value,
          file: URL.createObjectURL(companyAvatar.value),
        };
      } else if (file.target.files[0].size > 10_000_000) {
        alertHelper.show(alert, t("files.errors.size"), "", "error");
      } else {
        alertHelper.show(alert, t("profile.add_documents.file_type_error"), "", "error");
      }
    };

    const deleteProfilePicture = async () => {
      if (profilePictureToDisplay.value.id) {
        try {
          await userCompany.deleteCompanyFile(profilePictureToDisplay.value.id);
        } catch (e) {
          alertHelper.show(alert, t("profile.add_documents.delete_error"), "", "error");
        }
      }
      profilePictureToDisplay.value = null;
      companyAvatar.value = "";
    };

    const mapImagesToDisplay = () => {
      imagesToDisplay.value = companyGalery.value.map((image) => ({
        id: image.id,
        file: URL.createObjectURL(image.file),
      }));
    };

    const addPicture = (file) => {
      if (imagesToDisplay.value.length >= 10) {
        alertHelper.show(alert, "Maksymalnie można dodać 10 zdjęć do galerii", "", "error");
        return;
      }

      if (!checkFileType(file)) {
        alertHelper.show(alert, t("profile.add_documents.file_type_error"), "", "error");
        return;
      }

      if (file.size <= 10_000_000) {
        companyGalery.value.push({
          id: new Date().getTime(),
          file,
        });
        mapImagesToDisplay();
      } else if (file.size > 10_000_000) {
        alertHelper.show(alert, t("files.errors.size"), "", "error");
      }
    };

    const removeFromGalery = async (imageId) => {
      companyGalery.value = companyGalery.value.filter((elem) => elem.id !== imageId);
      if (galeryCopy.value.find((id) => id === imageId)) await userCompany.deleteCompanyFile(imageId);
      mapImagesToDisplay();
    };

    const saveCompanyColumn = handleSubmit(async () => {
      if (!authStore.isLoading) {
        authStore.isLoading = true;

        // Get selected licenses
        const selectedLicenseTypes = [];
        Object.entries(selectedLicenses.value).forEach(([licenseType, isSelected]) => {
          if (isSelected) {
            selectedLicenseTypes.push(licenseType);
          }
        });

        const data = {
          companyData: {
            companyName: company.value,
            displayName: displayName.value || null,
            companyNip: nip.value,
            companyPhone: phone.value,
            allowSms: checked.value,
            licenses: selectedLicenseTypes,
            companyAddresses: [
              {
                id: companyAddressId.value,
                companyAddress: address.value,
                companyCity: city.value,
                companyZipCode: zipCode.value,
                companyCountry: country.value,
              },
            ],
          },
        };

        try {
          await userCompany.editCompany(currCompany.value.id, data);
          if (companyAvatar.value) {
            try {
              await userCompany.uploadCompanyPicture(companyAvatar.value, currCompany.value.id, "COMPANY_AVATAR");
            } catch (e) {
              alertHelper.show(alert, t("profile.add_documents.file_type_error"), "", "error");
            }
          }
          if (!galleryUploading.value) {
            galleryUploading.value = true;
            for (let i = 0; i < companyGalery.value.length; i++) {
              if (typeof companyGalery.value[i].id === "number")
                await userCompany.uploadCompanyPicture(companyGalery.value[i].file, currCompany.value.id, "GALLERY");
            }
            galleryUploading.value = false;
          }
          const tempCompanyData = await userCompany.fetchOneCompany(currCompany.value.id);
          let role = await userCompany.getRoleInCompany(currCompany.value.id);
          if(role) storeCache.set("roleInCurrentCompany", role);
          storeCache.set("currentCompany", tempCompanyData);
          authStore.isLoading = false;
          storeCache.remove("verificationShown");
          storeCache.remove("ratingsShown");

          location.reload();
        } catch (err) {
          authStore.isLoading = false;
          alertHelper.show(alert, err, "", "error");
        }
      }
    });

    return {
      saveCompanyColumn,
      authStore,
      errors,
      address,
      company,
      displayName,
      city,
      zipCode,
      nip,
      fetched,
      phone,
      country,
      companyAvatar,
      handlePicture,
      companyGalery,
      imagesToDisplay,
      removeFromGalery,
      addPicture,
      roleInCompany,
      checked,
      profilePictureToDisplay,
      deleteProfilePicture,
      currCompany,
      // License management
      selectedLicenses,
      allLicenseTypes,
    };
  },
};
</script>

<style lang="scss" scoped>
/* License Management Styles */
.licenses-section {
  margin: 20px 0;
  padding: 20px;
  background: rgba(17, 43, 175, 0.02);
  border-radius: 10px;
  border: 1px solid rgba(162, 162, 162, 0.2);
  grid-column: span 2;
  
  @media screen and (max-width: 650px) {
    grid-column: span 1;
  }

  h3 {
    font-weight: 600;
    color: #112baf;
    font-size: 16px;
    margin-bottom: 15px;
    text-align: left;
  }
}

.licenses-wrapper {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
  margin-bottom: 15px;
}

.license-item {
  display: flex;
  align-items: center;
  padding: 10px;
  background: rgba(17, 43, 175, 0.02);
  border-radius: 8px;
  border: 1px solid rgba(17, 43, 175, 0.1);

  .license-checkbox {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;

    input[type="checkbox"] {
      width: 16px;
      height: 16px;
      accent-color: #112baf;
      cursor: pointer;
    }

    .license-label {
      font-weight: 500;
      font-size: 14px;
      color: #112baf;
      cursor: pointer;
      flex: 1;
    }
  }
}

.gallery-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  
  h1 {
    margin: 0;
  }
}

.image-counter {
  background: linear-gradient(135deg, #3498db, #2980b9);
  color: white;
  padding: 6px 12px;
  border-radius: 15px;
  font-weight: 600;
  font-size: 12px;
  min-width: fit-content;
}

.limit-message {
  background: linear-gradient(135deg, #f39c12, #e67e22);
  color: white;
  padding: 12px 20px;
  border-radius: 8px;
  text-align: center;
  font-weight: 600;
  margin-top: 15px;
  font-size: 14px;
}

.image-wrapper {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 15px;
  margin-bottom: 15px;
  
  > div {
    position: relative;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    
    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
      
      span {
        opacity: 1;
      }
    }
    
    img {
      width: 100%;
      height: 120px;
      object-fit: cover;
      display: block;
    }
    
    span {
      position: absolute;
      top: 8px;
      right: 8px;
      background: rgba(231, 76, 60, 0.9);
      color: white;
      border: none;
      border-radius: 50%;
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      opacity: 0;
      transition: all 0.3s ease;
      font-size: 14px;
      font-weight: bold;
      
      &:hover {
        background: #e74c3c;
        transform: scale(1.1);
      }
    }
  }
}

.image-wrapper-small {
  > div {
    position: relative;
    border-radius: 15px;
    overflow: hidden;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease;
    display: inline-block;
    
    &:hover {
      transform: translateY(-5px);
    }
    
    span {
      position: absolute;
      top: 8px;
      right: 8px;
      background: rgba(231, 76, 60, 0.9);
      color: white;
      border-radius: 50%;
      width: 28px;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      font-size: 16px;
      font-weight: bold;
      transition: all 0.3s ease;
      
      &:hover {
        background: #e74c3c;
        transform: scale(1.1);
      }
    }
  }
}

.galery-custom-btn {
  p {
    font-size: 12px;
    font-weight: 400;
    opacity: 0.5;
  }
  .input-as-button {
    margin: auto;
    color: #112baf;
    border: 1px solid #112baf;
    background: #fff;
    width: fit-content;
    padding: 8px 16px;
    font-weight: 600;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    
    &:hover {
      background: #112baf;
      color: white;
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(17, 43, 175, 0.3);
    }
    
    @media screen and (max-width: 1380px) {
      margin: 0;
    }
  }
  .no-margin {
    margin: 0;
  }
}
.section-title{
  color: #112baf;
  text-align: center;
  margin-bottom: 20px;
  font-weight: 600;
  font-size: 15px;
}
.grid-it {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  @media screen and (max-width: 650px) {
    grid-template-columns: 1fr;
  }
}

.span-col {
  grid-column: span 2;
  @media screen and (max-width: 650px) {
    grid-column: span 1;
  }
  
}

.col-2 {
  display: flex;
  justify-content: flex-start;
  gap: 40px;
  @media screen and (max-width: 1500px) {
    flex-direction: column;
    gap: 30px;
  }
}

h1 {
  min-width: fit-content;
  font-weight: 600;
  font-size: 16px;
  color: #1f222f;
  margin-bottom: 15px;
}

.picture-measurement {
  width: 120px;
  max-height: 120px;
  object-fit: contain;
}

@media (max-width: 768px) {
  .image-wrapper {
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
    gap: 10px;
    
    > div img {
      height: 100px;
    }
  }
  
  .picture-measurement {
    width: 100px;
    max-height: 100px;
  }
  
  .col-2 {
    gap: 20px;
  }

  .licenses-wrapper {
    grid-template-columns: 1fr;
    gap: 10px;
  }
}
</style>